export enum EEducationProgram {
  PRO_WB = 'prowb',
}

export enum ELinkId {
  COSTS_AND_PRICING = 'costsAndPricing',
  PRODUCT_DOCUMENTS = 'productDocuments',
  SALES_MODELS_FBO_FBS_DBS = 'salesModelsFboFbsDbs',
  WEBINAR_CALENDAR = 'webinarCalendar',
  ALL_MATERIALS = 'allMaterials',
  PRO_WB = 'proWb',

  PRODUCT_CARD_CREATION = 'productCardCreation',
  MULTIPLE_CARDS_ADDITION = 'multipleCardsAddition',
  SELLER_ANALYTICS = 'sellerAnalytics',
  BRAND_BUILDING = 'brandBuilding',
  GUIDE_FOR_NEW_SELLERS = 'guideForNewSellers',
}

export type TLink = {
  text: string;
  route: string;
  id: ELinkId;
  isResolveUrl?: boolean;
};

export type TEducationProgram = {
  blockName: EEducationProgram;
  level: string;
  name: string;
  description: string;
  links?: Array<TLink>;
  buttonLink?: string;
};

export type TEducationConfig = {
  title: string;
  button: string;
  programs: Array<TEducationProgram>;
  logoLink: string;
};
